const CenterWiseReportTypes = {
    GET_CENTER_WISE_REPORT_START: 'GET_CENTER_WISE_REPORT_START',
    GET_CENTER_WISE_REPORT_SUCCESS: 'GET_CENTER_WISE_REPORT_SUCCESS',
    GET_CENTER_WISE_REPORT_FAILURE: 'GET_CENTER_WISE_REPORT_FAILURE',
    GET_CENTER_WISE_REPORT_RESPONSE_RESET: 'GET_CENTER_WISE_REPORT_RESPONSE_RESET',
};
export default CenterWiseReportTypes;
